import React, { useState, useEffect } from "react";
import Layout from "../../component/layout";
import { getItem } from '../../../../utils/localStorage'
import { makeRequest2 } from '../../../../utils/makeRequest'
import { toastify } from '../../../../utils/toast'
import { addBlockedPlateURL, getBlockedPlatesURL, deleteBlockedPlateURL } from '../../../../utils/urls'

const BlockedPlates = () => {
    const [plateNumber, setPlateNumber] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [blockedPlates, setBlockedPlates] = useState([]);

    const handleAddPlate = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            if (!plateNumber) {
                throw new Error('Plate number is required');
            }
            const response = await makeRequest2(`${addBlockedPlateURL}/${facilityId}`, 'POST', {
                plateNumber,
            });

            if (response.success) {
                toastify('Plate added successfully', 'success');
                setPlateNumber('');
                // Refresh the list after adding
                getBlockedPlates();
            } else {
                throw new Error(response.error);
            }

        } catch (err) {

        }
    };

    const getBlockedPlates = async () => {
        try {
            const facilityId = await getItem('selectedFacilityId');
            const response = await makeRequest2(`${getBlockedPlatesURL}/${facilityId}`, 'GET');

            if (response.success) {
                setBlockedPlates(response.data);
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeletePlate = async (plateId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this plate?");
        if (!confirmDelete) return;

        try {
            const response = await makeRequest2(`${deleteBlockedPlateURL}/${plateId}`, 'DELETE');
            if (response.success) {
                toastify('Plate removed successfully', 'success');
                getBlockedPlates();
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            console.error(err);
            toastify('Failed to remove plate', 'error');
        }
    };


    // Filter plates based on search term
    const filteredPlates = blockedPlates.filter(plate =>
        plate.plateNumber.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        getBlockedPlates();
    }, []);

    return (
        <Layout>
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Blocked Plates</h5>
                                    </div>
                                    <div className='card-body'>
                                        <div className="row">
                                            <div className="col-lg-12 col-xxl-12">
                                                <div className="card">
                                                    <div className="card-body position-relative">

                                                        {/* Add New Plate Section */}
                                                        <div className="mb-4">
                                                            <h6 className="text-muted mb-3">Add New Blocked Plate</h6>
                                                            <div className="row g-3">
                                                                <div className="col-md-4">
                                                                    <label htmlFor="plateInput" className="form-label">Number Plate</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="plateInput"
                                                                        placeholder="e.g., KBC 111T"
                                                                        value={plateNumber}
                                                                        onChange={(e) => setPlateNumber(e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 d-flex align-items-end">
                                                                    <button
                                                                        className="btn btn-primary w-50"
                                                                        onClick={handleAddPlate}
                                                                    >
                                                                        Add Plate
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <hr />

                                                        {/* Search and List Section */}
                                                        <div>
                                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                                <h6 className="text-muted mb-0">
                                                                    Blocked Plates List ({filteredPlates.length})
                                                                </h6>
                                                                <div className="col-md-4">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Search plates..."
                                                                        value={searchTerm}
                                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Plates List */}
                                                            {filteredPlates.length === 0 ? (
                                                                <div className="text-center py-5 text-muted">
                                                                    <p className="mt-2">No blocked plates found</p>
                                                                </div>
                                                            ) : (
                                                                <div className="table-responsive">
                                                                    <table className="table table-hover">
                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th scope="col">Number Plate</th>
                                                                                <th scope="col">Date Added</th>
                                                                                <th scope="col" className="text-center">Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {filteredPlates.map((plate) => (
                                                                                <tr key={plate._id}>
                                                                                    <td>
                                                                                        <span className="badge bg-dark fs-6 font-monospace">
                                                                                            {plate.plateNumber}
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <small className="text-muted">
                                                                                            {new Date(plate.createdAt).toLocaleDateString()}
                                                                                        </small>
                                                                                    </td>
                                                                                    <td className="text-center">
                                                                                        <button
                                                                                            className="btn btn-outline-danger btn-sm"
                                                                                            onClick={() => handleDeletePlate(plate._id)}
                                                                                            title="Remove from blocked list"
                                                                                        >
                                                                                            Remove
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default BlockedPlates